module.exports = __webpack_public_path__ + "static/media/contact.efcaf382.jpg";